import { useTranslation } from "react-i18next";
import { useStorageSelectors } from "../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { DrawIoEditor } from "./Components/DrawIoEditor";
import { NoObjectChosen } from "../../common/NoObjectChosen";
import { useAppModals } from "../../app/state/modalSlice/hook/use-app-modals";

export const Schemas = () => {
  const { selectedObject } = useStorageSelectors("schemas");
  const { handleOpenModal } = useAppModals();
  const { t } = useTranslation();

  if (selectedObject?.value === null) {
    return (
      <NoObjectChosen
        message={t("schemas.no_object_message")}
        folderName={selectedObject.friendly_name}
        onClick={() => handleOpenModal("create_schema_object_modal", null)}
      />
    );
  }

  return <DrawIoEditor />;
};
